import { StyledForm } from '@framework/form/form/StyledForm.tsx';
import { t } from '@framework/i18n/intl/i18next.ts';
import { Drawer } from '@framework/ui/components/drawer/Drawer.tsx';
import { Button, Space } from 'antd';
import type React from 'react';
import styled from 'styled-components';
import { RichTextAdvancedRender } from '../../../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { DrawerButtonRow } from '../../../../../../../ui/drawer/DrawerButtonRow.tsx';
import { type ISubsectionWidget } from '../../ISubsectionWidget.ts';

const StyledSubsectionDrawerBodyWrapper = styled.div`
  max-width: ${props => props.theme.contentMaxWidth}px;
  margin: 0 auto;
`;

export interface ISubsectionDrawerProps {
  widget: ISubsectionWidget;
  children?: React.ReactNode;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export function SubsectionDrawer(props: ISubsectionDrawerProps) {
  const { widget, isOpen, setIsOpen } = props;
  return (
    <Drawer
      title={<RichTextAdvancedRender text={widget.label ?? 'Sottosezione'} />}
      size="large"
      width="90%"
      placement="right"
      onClose={() => {
        setIsOpen(false);
      }}
      open={isOpen}
      maskClosable={false}
    >
      <StyledSubsectionDrawerBodyWrapper>
        <StyledForm>{props.children}</StyledForm>
      </StyledSubsectionDrawerBodyWrapper>
      <DrawerButtonRow>
        <Space>
          <Button type="primary" size="large" onClick={() => setIsOpen(false)}>
            {t('subsection.drawer.button.back', 'Indietro')}
          </Button>
        </Space>
      </DrawerButtonRow>
    </Drawer>
  );
}
